import styled from 'styled-components';
import { typography } from '../../typography/typography.js';

var TextLinkWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__TextLinkWrapper",
  componentId: "sc-1y3f8u0-0"
})(["> a{font-family:", ";font-size:", ";line-height:", ";font-weight:", ";color:", ";:active,:hover{color:", ";svg{path{fill:", ";}}}svg{vertical-align:middle;height:14px;margin-left:4px;margin-right:4px;margin-bottom:1px;}", "}"], typography.fontFamily, typography.fontSize, typography.lineHeight, typography.fontWeightLight, function (_ref) {
  var theme = _ref.theme;
  return theme.colorPalette.primaryColors.main.shade_link;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colorPalette.primaryColors.main.shade_dark_2;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colorPalette.primaryColors.main.shade_dark_2;
}, function (_ref4) {
  var linkStyle = _ref4.linkStyle;
  return linkStyle;
});
process.env.NODE_ENV !== "production" ? TextLinkWrapper.displayName = 'TextLinkWrapper' : void 0;

export { TextLinkWrapper, TextLinkWrapper as default };
